/**
 * Navigation Hover Behavior - Fashion Nova Style
 * Enables hover-based dropdown/mega menu opening on desktop
 */
class NavigationHover {
  constructor() {
    this.headerMenus = document.querySelectorAll('header-menu');
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
    this.abortControllers = new Map(); // Store abort controllers for cleanup
    
    if (this.isDesktop) {
      this.init();
    }
    
    // Re-initialize on resize
    window.addEventListener('resize', () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
      
      if (wasDesktop !== this.isDesktop) {
        if (this.isDesktop) {
          this.init();
        } else {
          this.destroy();
        }
      }
    });
  }

  init() {
    // #region agent log
    fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:30',message:'Init started',data:{headerMenusCount:this.headerMenus.length,isDesktop:this.isDesktop},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
    // #endregion
    
    this.headerMenus.forEach((menu, index) => {
      const details = menu.querySelector('details');
      // #region agent log
      fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:34',message:'Processing menu',data:{index,hasDetails:!!details,menuId:menu.id},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion
      if (!details) return;

      const summary = details.querySelector('summary');
      if (!summary) return;

      const megaMenuContent = menu.querySelector('.mega-menu__content');
      const isMegaMenu = megaMenuContent !== null;
      // #region agent log
      fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:42',message:'Menu setup complete',data:{index,isMegaMenu,hasMegaContent:!!megaMenuContent},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion

      // Create abort controller for this menu to manage event listeners
      const abortController = new AbortController();
      this.abortControllers.set(menu, abortController);

      // Prevent click behavior on desktop - rely only on hover
      // We need to intercept BEFORE the native details toggle happens
      const preventInteraction = (e) => {
        // Double-check we're still on desktop (in case of rapid resize)
        if (window.matchMedia('(min-width: 990px)').matches) {
          // CRITICAL: Allow clicks on mega menu links and their children
          const target = e.target;
          const isLink = target.tagName === 'A' || target.closest('a');
          const isMegaMenuLink = target.classList.contains('mega-menu__link') || 
                                 target.closest('.mega-menu__link') ||
                                 target.closest('.mega-menu__content a');
          
          // If clicking on a link inside the mega menu, allow it
          if (isLink && isMegaMenuLink) {
            return; // Don't prevent - allow the link to work
          }
          
          // Also allow clicks on summary children (spans, icons) - they're fine
          if (target.closest('summary')) {
            // Only prevent if it's the summary itself or direct children that would toggle
            if (target === summary || summary.contains(target)) {
              // This is a click on the summary - prevent it
            } else {
              return; // Allow other interactions
            }
          }
          
          // Completely prevent the interaction from doing anything
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Immediately close if it was opened by click (not hover)
          if (details.hasAttribute('open') && !menu.dataset.hoverTriggered) {
            // Use requestAnimationFrame to ensure it happens after the toggle
            requestAnimationFrame(() => {
              if (!menu.dataset.hoverTriggered) {
                details.removeAttribute('open');
              }
            });
          }
          
          return false;
        }
      };
      
      // Also prevent on the summary's children (like the span and icon)
      const preventChildInteraction = (e) => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          // CRITICAL: Allow clicks on mega menu links
          const target = e.target;
          const isLink = target.tagName === 'A' || target.closest('a');
          const isMegaMenuLink = target.classList.contains('mega-menu__link') || 
                                 target.closest('.mega-menu__link') ||
                                 target.closest('.mega-menu__content a');
          
          // If clicking on a link inside the mega menu, allow it
          if (isLink && isMegaMenuLink) {
            return; // Don't prevent - allow the link to work
          }
          
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      };

      // Intercept toggle event to prevent click-based toggling
      const handleToggle = (e) => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          // Only allow toggle if it was triggered by hover
          if (!menu.dataset.hoverTriggered) {
            // If toggle happened from a click (not hover), immediately close it
            // Use requestAnimationFrame to ensure it happens synchronously
            requestAnimationFrame(() => {
              if (!menu.dataset.hoverTriggered && details.hasAttribute('open')) {
                details.removeAttribute('open');
              }
            });
          }
        }
      };
      
      // Make summary not act as a clickable element on desktop
      // Use CSS to help prevent clicks
      if (window.matchMedia('(min-width: 990px)').matches) {
        summary.style.pointerEvents = 'auto'; // Allow hover
        // Add a data attribute to help CSS target it
        summary.setAttribute('data-hover-only', 'true');
      }

      // Prevent mousedown (fires before click) - most important
      summary.addEventListener('mousedown', preventInteraction, { 
        capture: true,
        passive: false,
        signal: abortController.signal 
      });

      // Also prevent click as backup
      summary.addEventListener('click', preventInteraction, { 
        capture: true,
        passive: false,
        signal: abortController.signal 
      });
      
      // Prevent interactions on all children of summary
      summary.querySelectorAll('*').forEach(child => {
        child.addEventListener('mousedown', preventChildInteraction, { 
          capture: true,
          passive: false,
          signal: abortController.signal 
        });
        child.addEventListener('click', preventChildInteraction, { 
          capture: true,
          passive: false,
          signal: abortController.signal 
        });
      });

      // CRITICAL: Intercept toggle event to prevent click-based toggling
      details.addEventListener('toggle', handleToggle, { 
        capture: true,
        signal: abortController.signal 
      });

      // Also add to the details element itself as a backup
      // But only prevent if clicking on the details/summary itself, not on links inside
      const preventDetailsInteraction = (e) => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          const target = e.target;
          
          // Always allow clicks on links inside mega menu content
          if (target.tagName === 'A' || target.closest('a.mega-menu__link') || target.closest('.mega-menu__content a')) {
            return; // Allow link clicks
          }
          
          // Only prevent if clicking directly on details or summary
          if (target === details || target === summary || summary.contains(target)) {
            preventInteraction(e);
          }
        }
      };
      
      details.addEventListener('mousedown', preventDetailsInteraction, { 
        capture: true,
        passive: false,
        signal: abortController.signal 
      });

      details.addEventListener('click', preventDetailsInteraction, { 
        capture: true,
        passive: false,
        signal: abortController.signal 
      });

      // Open on hover - ensure details opens immediately and content is visible
      const handleMouseEnter = () => {
        // #region agent log
        fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:151',message:'MouseEnter triggered',data:{index,isMegaMenu,detailsOpen:details.hasAttribute('open')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
        // #endregion
        
        // Set flag to allow toggle event (from hover)
        menu.dataset.hoverTriggered = 'true';
        
        // Always ensure details is open on hover
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
        
        // Immediately show content with inline styles
        const content = megaMenuContent || menu.querySelector('.header__submenu');
        // #region agent log
        fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:162',message:'Content found',data:{index,hasContent:!!content,contentClass:content?.className},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
        // #endregion
        
        if (content) {
          // Calculate top position based on header bottom (for fixed positioning)
          const headerWrapper = document.querySelector('.header-wrapper');
          // #region agent log
          fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:166',message:'Header wrapper check',data:{hasHeaderWrapper:!!headerWrapper,headerZIndex:headerWrapper?.style.zIndex},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
          // #endregion
          let topPosition = '100%';
          if (headerWrapper) {
            const headerRect = headerWrapper.getBoundingClientRect();
            topPosition = `${headerRect.bottom}px`;
          }
          
          // Apply inline styles immediately AND in requestAnimationFrame as backup
          // Mega menu uses fixed positioning for consistent edge-to-edge regardless of menu item position
          // Top position is calculated dynamically from header bottom to maintain connection to navigation
          const applyStyles = () => {
            // Use setProperty with !important flag to ensure styles override CSS
            content.style.setProperty('opacity', '1', 'important');
            content.style.setProperty('visibility', 'visible', 'important');
            content.style.setProperty('display', 'block', 'important');
            content.style.setProperty('transform', 'translateY(0)', 'important');
            content.style.setProperty('pointer-events', 'auto', 'important');
            content.style.setProperty('z-index', '1000', 'important');
            content.style.setProperty('position', 'fixed', 'important');
            content.style.setProperty('left', '0', 'important');
            content.style.setProperty('right', '0', 'important');
            content.style.setProperty('width', '100vw', 'important');
            content.style.setProperty('top', topPosition, 'important');
            content.style.setProperty('overflow-x', 'hidden', 'important');
            content.style.setProperty('height', 'auto', 'important');
          };
          
          // Apply immediately
          applyStyles();
          
          // #region agent log
          fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:193',message:'Styles applied',data:{index,opacity:content.style.opacity,visibility:content.style.visibility,display:content.style.display,zIndex:content.style.zIndex,computedDisplay:window.getComputedStyle(content).display},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'B'})}).catch(()=>{});
          // #endregion
          
          // Also apply in next frame as backup
          requestAnimationFrame(() => {
            applyStyles();
            // Force style recalculation
            void content.offsetHeight;
            // #region agent log
            fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:200',message:'RAF styles applied',data:{index,computedDisplay:window.getComputedStyle(content).display,computedVisibility:window.getComputedStyle(content).visibility,computedOpacity:window.getComputedStyle(content).opacity},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'B'})}).catch(()=>{});
            // #endregion
          });
        }
      };

      menu.addEventListener('mouseenter', handleMouseEnter, { 
        signal: abortController.signal 
      });
      // #region agent log
      fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:204',message:'Mouseenter listener attached',data:{index,isMegaMenu},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'D'})}).catch(()=>{});
      // #endregion

      // Close on mouse leave (with small delay for better UX)
      let closeTimeout;
      const handleMouseLeave = () => {
        closeTimeout = setTimeout(() => {
          // Clear hover flag
          delete menu.dataset.hoverTriggered;
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
          }
        }, 200); // Slightly longer delay for mega menus with images
      };

      menu.addEventListener('mouseleave', handleMouseLeave, { 
        signal: abortController.signal 
      });

      // For mega menus, also handle mouse leave on the content itself
      if (isMegaMenu && megaMenuContent) {
        const handleMegaMenuEnter = () => {
          if (closeTimeout) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
          }
        };

        megaMenuContent.addEventListener('mouseenter', handleMegaMenuEnter, { 
          signal: abortController.signal 
        });

        megaMenuContent.addEventListener('mouseleave', handleMouseLeave, { 
          signal: abortController.signal 
        });
      }

      // Cancel close if mouse re-enters
      menu.addEventListener('mouseenter', () => {
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
      }, { signal: abortController.signal });
    });
  }

  destroy() {
    // Remove hover behavior on mobile and restore click behavior
    this.headerMenus.forEach((menu) => {
      const details = menu.querySelector('details');
      if (details && details.hasAttribute('open')) {
        details.removeAttribute('open');
      }
      
      // Abort all event listeners for this menu (removes click prevention)
      const abortController = this.abortControllers.get(menu);
      if (abortController) {
        abortController.abort();
        this.abortControllers.delete(menu);
      }
    });
  }
}

// Initialize immediately - run as soon as script loads
// This ensures we intercept events before other scripts
(function() {
  let instance = null;
  
  function init() {
    // #region agent log
    fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:275',message:'Init function called',data:{readyState:document.readyState,headerMenusCount:document.querySelectorAll('header-menu').length},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
    // #endregion
    
    // If instance already exists, destroy it first
    if (instance) {
      try {
        instance.destroy();
      } catch(e) {}
    }
    
    // Try to initialize immediately
    try {
      instance = new NavigationHover();
      // #region agent log
      fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:288',message:'NavigationHover instance created',data:{isDesktop:instance.isDesktop,headerMenusCount:instance.headerMenus.length},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion
    } catch(e) {
      // #region agent log
      fetch('http://127.0.0.1:7246/ingest/c95bc397-6746-44a9-93cb-763d7638d6e2',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'navigation-hover.js:291',message:'NavigationHover init failed',data:{error:e.message,stack:e.stack},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion
      // If it fails, wait a bit and try again
      setTimeout(() => {
        try {
          instance = new NavigationHover();
        } catch(e2) {
          console.warn('NavigationHover initialization failed:', e2);
        }
      }, 50);
    }
  }

  // Run immediately if DOM is ready
  if (document.readyState === 'loading') {
    // DOM still loading - wait for it
    document.addEventListener('DOMContentLoaded', init);
    // But also try immediately in case elements exist
    setTimeout(init, 0);
  } else {
    // DOM already ready - run immediately
    init();
  }
  
  // Also re-initialize multiple times to catch late-loading elements
  setTimeout(init, 50);
  setTimeout(init, 150);
  setTimeout(init, 300);
})();

